import filter from "lodash/filter";
import keys from "lodash/keys";

export const makeQueryStringValue = (
  value: string | (string | number)[]
): string => {
  if (!Array.isArray(value)) {
    return encodeURIComponent(value);
  }

  return value.map(item => encodeURIComponent(item)).join(",");
};

export const makeQueryString = (
  params?: Record<string, any>,
  splitArray = false
): string => {
  let queryString = "";
  if (params && Object.keys(params).length) {
    queryString = `?${filter(keys(params), key => params[key] != null)
      .map(key => {
        const value = params[key];
        if (Array.isArray(value) && splitArray) {
          return value
            .map(
              item => `${encodeURIComponent(key)}=${makeQueryStringValue(item)}`
            )
            .join("&");
        }
        return `${encodeURIComponent(key)}=${makeQueryStringValue(
          params[key]
        )}`;
      })
      .join("&")}`;
  }

  return queryString;
};
